import React from "react";
import classNames from "classnames";

export const PlayIcon = ({ className, fill }) => (
  <svg
    className={className}
    fill={fill}
    width="10"
    height="13"
    viewBox="0 0 10 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.46256 5.34052C7.78164 5.58055 7.78165 6.05947 7.46256 6.29949L1.83066 10.536C1.43523 10.8334 0.869975 10.5513 0.869975 10.0565L0.869975 1.58351C0.869975 1.08869 1.43523 0.806569 1.83066 1.10403L7.46256 5.34052Z" />
  </svg>
);

export const ImageIcon = ({ className }) => (
  <svg
    aria-hidden="true"
    data-prefix="far"
    data-icon="image"
    className={classNames("svg-inline--fa", "fa-image", "fa-w-16", className)}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
    />
  </svg>
);
export const ImageSolidIcon = ({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    data-prefix="fas"
    data-icon="image"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    />
  </svg>
);
export const ImagesIcon = ({ className }) => (
  <svg
    aria-hidden="true"
    data-prefix="fas"
    data-icon="images"
    className={classNames("svg-inline--fa", "fa-images", "fa-w-18", className)}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    />
  </svg>
);

export const CloudUpload = ({ className }) => (
  <svg
    aria-hidden="true"
    data-prefix="fas"
    data-icon="cloud-upload-alt"
    className={classNames(
      "svg-inline--fa",
      "fa-cloud-upload-alt",
      "fa-w-20",
      className
    )}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
  >
    <path d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z" />
  </svg>
);
export const FolderOpen = ({ className }) => (
  <svg
    aria-hidden="true"
    data-prefix="fas"
    data-icon="folder-open"
    className={classNames(
      "svg-inline--fa",
      "fa-folder-open",
      "fa-w-18",
      className
    )}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path d="M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z" />
  </svg>
);
export const LandscapeIcon = ({ className }) => (
  <svg
    width="28"
    height="20"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M25 2H3C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H25C25.5523 18 26 17.5523 26 17V3C26 2.44772 25.5523 2 25 2Z"
      stroke="currentColor"
      strokeWidth="3"
    />
  </svg>
);
export const PortraitIcon = ({ className }) => (
  <svg
    width="20"
    height="28"
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 3L2 25C2 25.5523 2.44772 26 3 26H17C17.5523 26 18 25.5523 18 25V3C18 2.44771 17.5523 2 17 2H3C2.44772 2 2 2.44772 2 3Z"
      stroke="currentColor"
      strokeWidth="3"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/index.js